import comicReducer from './comicSlice';
import initReducer from './initSlice';

export const rootReducers = {
  init: initReducer,
  comic: comicReducer,
};
